import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IDeleteCampaignStepPayload {
    campaignId: string
    stepId: string
    sagaCB?: {
        onSuccess: any
    }
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const deleteCampaignStep = createSlice({
    name: 'campaigns/delete-campaign-step',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IDeleteCampaignStepPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const deleteCampaignStepActions = deleteCampaignStep.actions
export default deleteCampaignStep.reducer
